/* Cart "Copy link" popup.
   Buttons come from snippets/copy-link-button.liquid: data-copy-link-cart
   shares the whole cart, data-copy-link-key="<line key>" shares one line
   (plus the Zepto "Item Personalization" fee line that belongs to it).
   On click we read /cart.js, pack the chosen lines into a compressed token
   and show a link to the shared-cart page (assets/shared-cart.js unpacks it).
   Click handling is delegated so it keeps working after the cart drawer or
   cart page re-renders its HTML. */
(function () {
  var modal = null;
  var input = null;
  var copyButton = null;
  var copyLabel = null;
  var status = null;
  var lastTrigger = null;
  var resetTimer = null;
  var buildId = 0;

  function ready() {
    modal = document.getElementById('CopyLinkModal');
    if (!modal) return;

    input = modal.querySelector('#CopyLinkModalInput');
    copyButton = modal.querySelector('[data-copy-link-copy]');
    copyLabel = modal.querySelector('[data-copy-link-copy-label]');
    status = modal.querySelector('.copy-link-modal__status');

    // Stop clicks inside the popup from reaching document.body. The cart
    // drawer closes itself on any body click outside of it, and the popup
    // sits outside the drawer.
    modal.addEventListener('click', function (event) {
      event.stopPropagation();
      if (event.target.closest('[data-copy-link-close]')) {
        close();
        return;
      }
      if (event.target.closest('[data-copy-link-copy]')) {
        copy();
      }
    });

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-copy-link-cart], [data-copy-link-key]');
      if (!trigger) return;
      event.preventDefault();
      open(trigger);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) {
        event.stopPropagation();
        close();
      }
    });
  }

  /* ---------- popup ---------- */

  function open(trigger) {
    lastTrigger = trigger;
    clearTimeout(resetTimer);
    input.value = modal.getAttribute('data-building-label') || '';
    status.textContent = '';
    copyLabel.textContent = copyLabel.getAttribute('data-default-label');
    copyButton.classList.remove('is-copied');
    copyButton.disabled = true;
    modal.hidden = false;
    document.body.classList.add('copy-link-modal-open');

    var thisBuild = ++buildId;
    var lineKey = trigger.getAttribute('data-copy-link-key');

    buildLink(lineKey)
      .then(function (url) {
        if (thisBuild !== buildId || modal.hidden) return;
        input.value = url;
        copyButton.disabled = false;
        copyButton.focus();
      })
      .catch(function (err) {
        if (thisBuild !== buildId || modal.hidden) return;
        input.value = '';
        status.textContent = modal.getAttribute('data-error-label') || '';
        if (window.console) console.error('copy-link:', err);
      });
  }

  function close() {
    buildId++;
    modal.hidden = true;
    document.body.classList.remove('copy-link-modal-open');
    if (lastTrigger && document.body.contains(lastTrigger)) {
      lastTrigger.focus();
    }
    lastTrigger = null;
  }

  function copy() {
    var text = input.value;
    if (!text || copyButton.disabled) return;

    var done = function () {
      showCopied();
    };
    var failed = function () {
      input.focus();
      input.select();
      status.textContent = modal.getAttribute('data-failed-label') || '';
    };

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(done).catch(function () {
        legacyCopy() ? done() : failed();
      });
    } else {
      legacyCopy() ? done() : failed();
    }
  }

  function legacyCopy() {
    try {
      input.focus();
      input.select();
      input.setSelectionRange(0, input.value.length);
      return document.execCommand('copy');
    } catch (err) {
      return false;
    }
  }

  function showCopied() {
    var copiedLabel = modal.getAttribute('data-copied-label') || 'Copied!';
    var defaultLabel = copyLabel.getAttribute('data-default-label');
    copyLabel.textContent = copiedLabel;
    copyButton.classList.add('is-copied');
    clearTimeout(resetTimer);
    resetTimer = setTimeout(function () {
      copyLabel.textContent = defaultLabel;
      copyButton.classList.remove('is-copied');
    }, 2500);
  }

  /* ---------- link building ---------- */

  // Preferred: POST the payload to the app proxy and get a short link back
  // (momentotrunks.com/a/s/kx7Qm). Fallback: the long self-contained token
  // link to the shared-cart page, used if the proxy is unset or fails.
  function buildLink(lineKey) {
    var cartUrl = modal.getAttribute('data-cart-url') || '/cart.js';

    return fetch(cartUrl, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('cart.js ' + response.status);
        return response.json();
      })
      .then(function (cart) {
        var lines = collectLines(cart, lineKey);
        if (!lines.length) throw new Error('no lines to share');
        var payload = {
          v: 1,
          i: lines.map(function (line) {
            var entry = [line.variant_id, line.quantity];
            if (line.properties && Object.keys(line.properties).length) {
              entry.push(line.properties);
            }
            return entry;
          })
        };
        return shortLink(payload).catch(function (err) {
          if (window.console) console.warn('copy-link: short link failed, using long link', err);
          return longLink(payload);
        });
      });
  }

  function shortLink(payload) {
    var proxyPath = (modal.getAttribute('data-proxy-path') || '').replace(/\/+$/, '');
    var shopUrl = modal.getAttribute('data-shop-url') || window.location.origin;
    if (!proxyPath) return Promise.reject(new Error('no proxy path'));

    return fetch(proxyPath + '/new', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('proxy ' + response.status);
        return response.json();
      })
      .then(function (data) {
        if (!data || !data.path) throw new Error('proxy response missing path');
        return shopUrl + data.path;
      });
  }

  function longLink(payload) {
    var shareUrl = modal.getAttribute('data-share-url');
    return encodePayload(payload).then(function (token) {
      var joiner = shareUrl.indexOf('?') === -1 ? '?' : '&';
      return shareUrl + joiner + 'c=' + token;
    });
  }

  // Whole cart: every line as-is. One line: that line plus its Zepto fee
  // line. The personalized line carries _pc_pricing_qty_split = "<fee
  // variant id>-<qty>"; fee lines are interchangeable (same variant, same
  // price), so the nth personalized line takes the nth matching fee line.
  function collectLines(cart, lineKey) {
    if (!lineKey) return cart.items.slice();

    var line = null;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].key === lineKey) {
        line = cart.items[i];
        break;
      }
    }
    if (!line) return [];

    var out = [line];
    var split = line.properties && line.properties._pc_pricing_qty_split;
    if (split) {
      var feeId = parseInt(String(split).split('-')[0], 10);
      if (feeId) {
        var siblings = cart.items.filter(function (item) {
          var s = item.properties && item.properties._pc_pricing_qty_split;
          return s && String(s).indexOf(feeId + '-') === 0;
        });
        var fees = cart.items.filter(function (item) {
          return item.variant_id === feeId;
        });
        var fee = fees[siblings.indexOf(line)];
        if (fee) out.push(fee);
      }
    }
    return out;
  }

  /* ---------- encoding ---------- */

  // Token format: one prefix letter + base64url bytes.
  //   z = JSON, UTF-8, deflate (zlib) compressed
  //   j = JSON, UTF-8, uncompressed (fallback for browsers without CompressionStream)
  function encodePayload(payload) {
    var json = JSON.stringify(payload);
    var bytes = new TextEncoder().encode(json);

    if (typeof CompressionStream !== 'function') {
      return Promise.resolve('j' + bytesToBase64Url(bytes));
    }

    return new Response(
      new Blob([bytes]).stream().pipeThrough(new CompressionStream('deflate'))
    )
      .arrayBuffer()
      .then(function (buffer) {
        return 'z' + bytesToBase64Url(new Uint8Array(buffer));
      })
      .catch(function () {
        return 'j' + bytesToBase64Url(bytes);
      });
  }

  function bytesToBase64Url(bytes) {
    var binary = '';
    for (var i = 0; i < bytes.length; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
